import React, { useMemo, useRef, useImperativeHandle, forwardRef } from 'react';
import { CellLeftV8, CellYesNoV8, TablePaginatedV8, order2Sorting } from 'motion-components';
import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import {
  firstDateUserColumn,
  lastDateUserColumn,
  gridRowSelectedStyle,
} from 'shared-pages/common/grid-helpfunc';

/* ----------- Read-only Grid: appparams ------------------ */
export const DataGrid = forwardRef((props: any, ref) => {
  const {
    data,
    initPageIndex,
    onPageChange,
    loading,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
    dataCount,
  } = props;
  const { appStore, tableStore } = useRootStore();
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      {
        id: 'id',
        header: t('ID'),
        columnName: t('ID'),
        accessorKey: 'id',
        orderByField: 'id',
        cell: CellLeftV8,
        size: 5,
      },
      {
        id: 'paramGroup',
        header: t('Ομάδα Παραμέτρων'),
        columnName: t('Ομάδα Παραμέτρων'),
        accessorKey: 'paramGroup',
        orderByField: 'paramGroup',
        cell: CellLeftV8,
        size: 16,
      },
      {
        id: 'paramName',
        header: t('Όνομα Παραμέτρου'),
        columnName: t('Όνομα Παραμέτρου'),
        accessorKey: 'paramName',
        orderByField: 'paramName',
        cell: CellLeftV8,
        size: 24,
      },
      {
        id: 'description',
        header: t('Περιγραφή'),
        columnName: t('Περιγραφή'),
        accessorKey: 'description',
        orderByField: 'description',
        cell: CellLeftV8,
        size: 22,
      },
      {
        id: 'notes',
        header: t('Σημειώσεις'),
        columnName: t('Σημειώσεις'),
        accessorKey: 'notes',
        orderByField: 'notes',
        cell: CellLeftV8,
        size: 22,
      },
      {
        id: 'paramValue',
        header: t('Τιμή'),
        columnName: t('Τιμή'),
        accessorKey: 'paramValue',
        orderByField: 'paramValue',
        cell: CellYesNoV8,
        size: 18,
      },
      firstDateUserColumn(t),
      lastDateUserColumn(t),
    ],
    [t],
  );

  const tableRef = useRef(null);
  useImperativeHandle(ref, () => (tableRef.current ? tableRef.current : null));

  return (
    <LoadingOverlay active={loading} spinner text={t('Παρακαλώ περιμένετε...')}>
      {data ? (
        <TablePaginatedV8
          ref={tableRef}
          loading={loading}
          id="appparams-grid"
          appStore={appStore}
          tableStore={tableStore as any}
          key="appparams-grid"
          columns={columns as any}
          data={data}
          dataCount={dataCount}
          onRowClick={(table) => setSelected && setSelected(table.row.original)}
          rowProps={(row: any) => {
            let style: any = undefined;
            if (row.original.id === selected?.id) style = gridRowSelectedStyle;
            return { style: style };
          }}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          initSorting={order2Sorting(initOrderBy)}
          onSortByChange={(sort, columnDef, orderBy) => {
            onOrderChange && onOrderChange(orderBy);
          }}
          topBorderRadius={false}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
  );
});

DataGrid.displayName = 'GlobalParamsDataGrid';
